import React, { useState } from 'react';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ContactUsSection = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    user_name: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:contact@aped-investment.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.user_name}\n\n${formData.message}`)}`;
    window.location.href = mailtoLink;
  };

  return (
    <section className="aped-contact-us-section">
      <div className="aped-contact-us-content-wrapper">
        <h2 className="aped-contact-us-title">{t('contact.title')}</h2>
        <div className="aped-contact-us-content">
          <div className="aped-contact-info">
            <h3>{t('contact.info.title')}</h3>
            <div className="aped-contact-grid">
              <div className="aped-contact-item">
                <MapPin className="aped-contact-icon" />
                <p>{t('contact.info.address')}</p>
              </div>
              <a href="tel:+237670554129" className="aped-contact-item">
                <Phone className="aped-contact-icon" />
                <p>+237 670 554 129</p>
              </a>
              <a href="tel:+237699648403" className="aped-contact-item">
                <Phone className="aped-contact-icon" />
                <p>+237 699 648 403</p>
              </a>
              <a href="mailto:contact@aped-investment.com" className="aped-contact-item">
                <Mail className="aped-contact-icon" />
                <p>contact@aped-investment.com</p>
              </a>
            </div>
          </div>
          <div className="aped-contact-form">
            <h3 className="aped-form-title">{t('contact.form.title')}</h3>
            <form onSubmit={handleSubmit}>
              <div className="aped-form-grid">
                <div className="aped-form-group">
                  <label htmlFor="user_name">{t('contact.form.name')}</label>
                  <input
                    type="text"
                    id="user_name"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="aped-form-group">
                  <label htmlFor="subject">{t('contact.form.subject')}</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="aped-form-group">
                  <label htmlFor="message">{t('contact.form.message')}</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
              </div>
              <button type="submit" className="aped-submit-button">
                {t('contact.form.send')}
                <Send className="aped-submit-icon" />
              </button>
            </form>
          </div>
        </div>
      </div>
      <style jsx>{`
        .aped-contact-us-section {
          padding: 2rem 0.5rem;
          background-color: #f0f4f8;
          font-family: 'Inter', sans-serif;
          width: 100%;
          box-sizing: border-box;
          overflow-x: hidden;
        }

        .aped-contact-us-content-wrapper {
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
          padding: 0;
          box-sizing: border-box;
        }

        .aped-contact-us-title {
          font-size: 1.75rem;
          color: #1b1f3a;
          margin-bottom: 1.5rem;
          text-align: center;
          position: relative;
        }

        .aped-contact-us-title::after {
          content: '';
          display: block;
          width: 50px;
          height: 3px;
          background-color: #b4a35e;
          margin: 0.75rem auto 0;
        }

        .aped-contact-us-content {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 1.5rem;
        }

        .aped-contact-info,
        .aped-contact-form {
          width: 100%;
          background: white;
          border-radius: 10px;
          padding: 1rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          margin-bottom: 1.5rem;
          box-sizing: border-box;
        }

        .aped-contact-info h3,
        .aped-contact-form h3 {
          font-size: 1.2rem;
          color: #1b1f3a;
          margin-bottom: 1rem;
          text-align: center;
        }

        .aped-contact-grid,
        .aped-form-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 0.75rem;
        }

        .aped-contact-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 0.75rem;
          color: #1b1f3a;
          text-decoration: none;
          transition: color 0.3s ease;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          font-size: 0.85rem;
          word-break: break-word;
        }

        .aped-contact-item:hover {
          color: #b4a35e;
          background-color: #f8f9fa;
        }

        .aped-contact-icon {
          color: #b4a35e;
          margin-bottom: 0.4rem;
        }

        .aped-external-link-icon {
          margin-top: 0.4rem;
        }

        .aped-form-group {
          margin-bottom: 0.75rem;
        }

        .aped-form-group label {
          display: block;
          margin-bottom: 0.25rem;
          color: #1b1f3a;
          font-size: 0.85rem;
        }

        .aped-form-group input,
        .aped-form-group textarea {
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #bdc3c7;
          border-radius: 4px;
          font-size: 0.85rem;
          font-family: 'Inter', sans-serif;
          box-sizing: border-box;
          color: #1b1f3a;
        }

        .aped-form-group textarea {
          min-height: 80px;
          resize: vertical;
        }

        .aped-submit-button {
          background-color: #b4a35e;
          color: white;
          font-size: 0.95rem;
          font-weight: 600;
          padding: 0.75rem 1rem;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          width: 100%;
          margin-top: 0.75rem;
        }

        .aped-submit-button:hover {
          background-color: #c9b87d;
        }

        .aped-submit-icon {
          margin-left: 0.5rem;
        }

        @media (min-width: 640px) {
          .aped-contact-us-section {
            padding: 2.5rem 1rem;
          }

          .aped-contact-grid,
          .aped-form-grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (min-width: 768px) {
          .aped-contact-us-section {
            padding: 4rem 2rem;
          }

          .aped-contact-us-content-wrapper {
            max-width: 1200px;
            padding: 0 1rem;
          }

          .aped-contact-us-title {
            font-size: 2.25rem;
          }

          .aped-contact-us-content {
            flex-direction: row;
            justify-content: space-between;
            gap: 2rem;
          }

          .aped-contact-info,
          .aped-contact-form {
            width: 50%;
            padding: 2rem;
          }

          .aped-contact-info h3,
          .aped-contact-form h3 {
            font-size: 1.5rem;
          }

          .aped-contact-grid,
          .aped-form-grid {
            grid-template-columns: 1fr;
          }

          .aped-contact-item {
            flex-direction: row;
            justify-content: flex-start;
            text-align: left;
            font-size: 1rem;
          }

          .aped-contact-icon {
            margin-right: 1rem;
            margin-bottom: 0;
          }

          .aped-external-link-icon {
            margin-left: auto;
            margin-top: 0;
          }

          .aped-form-group label {
            font-size: 1rem;
          }

          .aped-form-group input,
          .aped-form-group textarea {
            font-size: 1rem;
            padding: 0.75rem;
          }

          .aped-submit-button {
            font-size: 1.1rem;
            padding: 0.75rem 1.5rem;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactUsSection;
